/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ImageHelper, ITeamModel } from "@bms/common";

import { ImageWithPlaceholder } from "components/ImageWithPlaceholder";
import resources from "resources/list";

import "./MatchTeamHeader.scss";

type IMatchTeamHeaderProps = {
  team?: ITeamModel;
};

export const MatchTeamHeader = ({ team }: IMatchTeamHeaderProps) => {
  if (!team) {
    return null;
  }

  const teamLogo = ImageHelper.getSquareImage(team?.Images);

  return (
    <div className="MatchTeamHeader">
      <ImageWithPlaceholder
        imageData={teamLogo}
        imageContainerClassName="MatchTeamHeader__image-container"
        imageClassName="MatchTeamHeader__image"
        placeholderSrc={resources.squarePlaceholder}
        placeholderClassName="MatchTeamHeader__placeholder"
        disableAbsolutePosition
      />
      <div className="MatchTeamHeader__name">{team.Name}</div>
    </div>
  );
};
